module.exports = __webpack_public_path__ + "img/AtmOutlined.7e91b046.svg";